import api from './client';
import ApiError from './error';

const CardService = {
  async getAllCards({ params }) {
    try {
      const client = await api.getClient();

      if (!params) {
        params = {};
      }

      if (params.ssn) {
        params.ssn = `${params.ssn}`;
      }

      return client.getCards(params);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async createCard({ type, account }) {
    try {
      const client = await api.getClient();

      return client.createCard(null, {
        type,
        account,
      });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async getAllAllocations() {
    try {
      const client = await api.getClient();
      return client.getAllCardAllocations();
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async purchaseCredits({ cardId, product }) {
    try {
      const client = await api.getClient();
      return client.cardTransaction({ cardId }, {
        product,
        operation: 'purchase',
      });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async spendCredits({ cardId, credits }) {
    try {
      const client = await api.getClient();
      return client.cardTransaction({ cardId }, {
        credits,
        operation: 'spending',
      });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async transferCredits({ cardId, recipient, credits }) {
    try {
      const client = await api.getClient();
      return client.cardTransaction({ cardId }, {
        credits,
        recipient,
        operation: 'transaction',
      });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async raiseCredits({ cardId, credits }) {
    try {
      const client = await api.getClient();
      return client.cardTransaction({ cardId }, {
        correction: Math.abs(credits),
        operation: 'correction',
      });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async decreaseCredits({ cardId, credits }) {
    try {
      const client = await api.getClient();
      return client.cardTransaction({ cardId }, {
        correction: -Math.abs(credits),
        operation: 'correction',
      });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async redeemAllocation({ cardId, allocationId, propertyCode }) {
    try {
      const client = await api.getClient();
      return client.redeemCardAllocation({ cardId, ruleId: allocationId }, { propertyCode });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async searchCardTransaction({ params }) {
    try {
      const client = await api.getClient();

      if (!params) {
        params = {};
      }

      if (params.account) {
        params.account = `${params.account}`;
      }

      if (params.from) {
        params.from = `${params.from}`;
      }

      if (params.to) {
        params.to = `${params.to}`;
      }

      if (params.type) {
        params.type = `${params.type}`;
      }

      return client.searchCardTransaction(params);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default CardService;
